export default "__VITE_ASSET__8681c4fb__"